import { render, staticRenderFns } from "./user_ranking.vue?vue&type=template&id=48c46221"
import script from "./user_ranking.vue?vue&type=script&lang=ts"
export * from "./user_ranking.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports